module.exports = __webpack_public_path__ + "img/TNT_LOGO_GOLD_02.a5d35e3b.png";